



































import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  GQL_ameldingsInYear_ameldings_ameldingWorkRelations,
  GQL_ameldingsInYear_ameldings_ameldingWorkRelations_workRelation,
  GQL_ameldingsInYear_ameldings_ameldingWorkRelations_ameldingWorkRelationLeaveAndLayoffs_workRelationLeaveAndLayoff,
} from '@/queries/__generated__/ameldingsInYear';
import Altinn from '@/app/Altinn';

@Component
export default class AmeldingListWorkRelation extends Vue {
  @Prop({ type: Object, required: true }) private altinnWorkRelation!: GQL_ameldingsInYear_ameldings_ameldingWorkRelations;
  public get workRelation(): GQL_ameldingsInYear_ameldings_ameldingWorkRelations_workRelation {
    return this.altinnWorkRelation.workRelation;
  }
  public get leaveAndLayoffs(): GQL_ameldingsInYear_ameldings_ameldingWorkRelations_ameldingWorkRelationLeaveAndLayoffs_workRelationLeaveAndLayoff[] {
    return this.altinnWorkRelation.ameldingWorkRelationLeaveAndLayoffs.map(altinnLeaveAndLayoff => {
      return altinnLeaveAndLayoff.workRelationLeaveAndLayoff;
    });
  }

  private Altinn = Altinn;
}
